<!--<div class="toolbar"></div>-->

<!--<div class="titlebar" id="header-container"></div>-->
<style class="css"></style>
<div class="screen-reader-content" tabindex="-1" id="page-loading" aria-hidden="true">{{t 'loadingPage'}}</div>
{{#if portfolio}}
<a data-action="portfolio" id="portfolio_button" tabindex="0" href="#">{{t 'portfolioButton'}}</a>
<div class="site-portfolio" tabindex="-1"></div>
{{/if}}
<div id="main-container" class="main"></div>
<div class="site-compatibility"></div>
<div id="audio-starter" style="display: none">
  <span>{{t 'audioFailedAlert'}}</span>
  <button class="btn btn-default" id="start_audio">{{t 'startAudioButton'}}</button>
</div>
{{#if showDev}}
<div aria-hidden="true">
  <div class="developer-toolbar row"></div>
  <div class="btn btn-default" id="developer_button">Developer Tools</div>
</div>
{{/if}}
